export default "__VITE_ASSET__c1cc1e51__"